/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { ICON, LOGINBG } from "../../assets/images";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { userRoutes, authRoutes } from "../../routes/mainRoutes/mainRoutes";
import CustomToast from "../../components/Toast";
import { loginAction, loginActionSuccess } from "../../store/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import { ThreeDots } from "react-loader-spinner";
import { getBeforeLoginMarqueeAction } from "../../store/actions/addNotification/addNotification";

const Login = () => {
  const dispatch = useDispatch();

  const [loginData, setLoginData] = useState({
    userCode: "",
    password: "",
  });
  const [passwordInputType, setPasswordInputType] = useState(true);
  // const [loader, setLoader] = useState(false);

  // useEffect(() => {
  //   window.localStorage.clear();
  // }, []);

  // useEffect(() => {
  //   // localStorage.clear();
  //   // sessionStorage.clear();
  //   const tokenCheck = setInterval(() => {
  //     localStorage.getItem("argument1") !== null && navigate("/dashboard");
  //   }, 1000);
  //   return () => {
  //     clearInterval(tokenCheck);
  //   };
  // }, []);
  const navigate = useNavigate();
  // const location = useLocation();

  const handleCopyPaste = (event) => {
    event.preventDefault();
  };

  const loadingLogin = useSelector((state) => state?.auth?.loadingLogin);

  const LoginLoaderStatus = useSelector(
    (state) => state?.auth?.LoginLoaderdata
  );

  const handleLogin = (e) => {
    e.preventDefault();
    const token =
      localStorage.getItem("argument1") || sessionStorage.getItem("argument1");

    if (token) {
      CustomToast.error(
        "Please close this tab as you are already logged in from another tab."
      );
      return;
    }
    let isValid = true;
    if (loginData.userCode == "") {
      CustomToast.error("Please enter your login");
      isValid = false;
      return;
    }

    if (loginData.password == "") {
      CustomToast.error("Please enter a password");
      isValid = false;
      return;
    }
    if(isValid){
      const confirmPopup = window.confirm('If any user with same login ID is active, his session will get expired on your login. Do you want to continue?');
      if (!confirmPopup) {
        // Redirect the user to logout or session expired page
        // Example: window.location.href = '/logout';
        isValid = false;
      }
    }
    if (isValid) {
      // dispatch(loginAction(loginData));
      const hashedPassword = CryptoJS.SHA256(loginData.password).toString(
        CryptoJS.enc.Hex
      );

      const updatedLoginData = {
        ...loginData,
        password: hashedPassword,
      };
      localStorage.setItem("currentTab", tabId);
      // setLoader(true);
      dispatch(loginAction(updatedLoginData));
    }
  };
  const handleClear = () => {
    setLoginData({
      userCode: "",
      password: "",
    });
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      document.getElementById("loginsubmitJS").click();
    }
  };
  const loginResponse = useSelector((state) => state?.auth?.loginData);
  const tabId =
    sessionStorage.getItem("tabId") ||
    `tab-${Math.random().toString(36).substr(2, 9)}`;
  console.log(tabId, "tabIdtabId");
  useEffect(() => {
    const handleTabClose = () => {
      if (localStorage.getItem("currentTab") === tabId) {
        localStorage.removeItem("argument1");
        sessionStorage.removeItem("argument1");
      }
    };

    const handleStorageChange = (event) => {
      if (event.key === "argument1" && event.newValue === null) {
        if (localStorage.getItem("currentTab") !== tabId) {
          navigate("/login");
        }
      }
    };

    window.addEventListener("beforeunload", handleTabClose);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate, tabId]);

  useEffect(() => {
    sessionStorage.setItem("tabId", tabId);
    const token =
      localStorage.getItem("argument1") || sessionStorage.getItem("argument1");
    if (token) {
      navigate("/dashboard");
      // setLoader(false);
    }
  }, [navigate, tabId]);

  useEffect(() => {
    if (loginResponse.statusCode === 200) {
      navigate("/dashboard");
      // setLoader(false);
      dispatch(loginActionSuccess(""));
    }
  }, [loginResponse, dispatch]);



  const [apiCalled, setApiCalled] = useState(false)
  const [activeMarquees, setActiveMarquees] = useState([])
  console.log("activeMarquees", activeMarquees)

  const allBeforeLoginMarquee = useSelector((state) => state?.addNotification?.beforeLoginMarquee || [])
  console.log("allBeforeLoginMarquee", allBeforeLoginMarquee)

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date()

      if (!apiCalled) {
        dispatch(getBeforeLoginMarqueeAction())
        setApiCalled(true)
      }

      // Filter active marquees based on current time
      if (Array.isArray(allBeforeLoginMarquee)) {
        const currentlyActive = allBeforeLoginMarquee?.filter((item) => {
          const start = new Date(item.startDate)
          const end = new Date(item.endDate)
          return now >= start && now <= end
        })
        setActiveMarquees(currentlyActive)
      }
      
    }, 1000)

    return () => clearInterval(interval)
  }, [apiCalled, dispatch, allBeforeLoginMarquee])


  return (
    <div>
      {loadingLogin ? (
        <div className="loading-login">
          <ThreeDots
            visible={true}
            height="80"
            width="80"
            color="#4fa94d"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      ) : (
        <div class="LoginBox">
          <div className="container-fluid">
            <div class="row">
              <div class="col-md-6 p-0">
                <div class="LoginBg">
                  <img src={LOGINBG} class="img-fluid" />
                </div>
              </div>
              <div class="col-md-6 p-0">
                <div class="LoginForm">
                  {activeMarquees.length > 0 && (
                    <div className="marquee">
                      <div className="marquee-text">
                        {activeMarquees.map((item, index) => (
                          <span key={index}>
                            {item.notificationText}
                            {index < activeMarquees.length - 1 && ' | '}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  <div class="row g-4">
                    <div class="col-md-12 mb-3">
                      <span className="LoginTitle">
                        <img src={ICON} className="img-fluid Logo" />
                      </span>
                    </div>
                    <div class="col-12 mt-2">
                      <h1>Login</h1>
                    </div>
                    <div class="col-lg-12 mt-2">
                      <input
                        type="text"
                        name="userCode"
                        value={loginData.userCode}
                        class="form-control"
                        placeholder="User Code"
                        onChange={(e) => {
                          setLoginData({
                            ...loginData,
                            userCode: e.target.value,
                          });
                        }}
                        onKeyPress={handleKeyPress}
                      />
                    </div>
                    <div class="col-lg-12 mt-2">
                      <div class="PasswordBox">
                        <input
                          id="password-field"
                          name="password"
                          type={passwordInputType ? "password" : "text"}
                          value={loginData.password}
                          className="form-control"
                          placeholder="Password"
                          onCopy={(e) => handleCopyPaste(e)}
                          onPaste={(e) => handleCopyPaste(e)}
                          onChange={(e) => {
                            setLoginData({
                              ...loginData,
                              password: e.target.value,
                            });
                          }}
                          onKeyPress={handleKeyPress}
                        />
                        <span
                          onClick={() =>
                            setPasswordInputType(!passwordInputType)
                          }
                          toggle="#password-field"
                          className="fa fa fa-eye field-icon toggle-password"
                        ></span>
                      </div>
                    </div>

                    <div className="col-lg-12 text-end">
                      <span
                        type="submit"
                        onClick={() => {
                          navigate("/forgot-password");
                        }}
                      >
                        <u>Forgot Password</u>
                      </span>
                    </div>
                    {/* <div class="col-lg-12 mt-3">
                    <input
                      type="submit"
                      value="Login"
                      class="LoginBtn"
                      onClick={() => {
                        let userCode = loginData.userCode.toString();

                        let password = loginData.password.toString();
                        if (
                          (userCode === "teaboard" &&
                            password === "teaboard") ||
                          (userCode === "auctioneer" &&
                            password === "auctioneer") ||
                          (userCode === "buyer" && password === "buyer")
                        ) {
                          sessionStorage.setItem(
                            "User",
                            JSON.stringify(loginData)
                          );
                          navigate("/dashboard");
                        } else {
                          toast.error("Incorrect credentials");
                        }
                      }}
                    />
                  </div> */}
                  </div>
                  <div>
                    <div className="col-md-12 mt-2">
                      <div className="BtnGroup d-flex justify-space-even">
                        <button
                          type="button"
                          className="LoginBtn"
                          id="loginsubmitJS"
                          onClick={(e) => handleLogin(e)}
                        >
                          Login
                        </button>
                        &nbsp;&nbsp;
                        <button
                          className="LoginBtn"
                          onClick={() => handleClear()}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
